// extracted by mini-css-extract-plugin
export default {"root":"HomeView_root__RTly4"};